import { render, staticRenderFns } from "./induction.vue?vue&type=template&id=36ce6cfb&scoped=true"
import script from "./induction.vue?vue&type=script&lang=js"
export * from "./induction.vue?vue&type=script&lang=js"
import style0 from "./induction.vue?vue&type=style&index=0&id=36ce6cfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce6cfb",
  null
  
)

export default component.exports